<template>
  <div :id="id" class="webRotate" />
</template>

<script setup>
import WR360 from '@webrotate360/imagerotator';

import { onMounted } from "vue";

const props = defineProps(
  {
    licence: {
      type: String,
      required: false,
      default: '',
    },
    rootPath: {
      type: String,
      required: false,
      default: ''
    },
    index: {
      type: String,
      required: true
    },
  }
)

const id = `webRotate--${Math.random().toString(16).slice(2)}`

onMounted(() => {
  document.getElementById('app').classList.add('h-100');
  document.getElementById('pageContent').classList.add('h-100');
  document.getElementById('pageContent')
    .querySelectorAll('.row')
    .forEach(el => {
      el.classList.add('h-100')
      el.classList.add('w-100')
      el.classList.add('p-0')
    });
  const viewer = WR360.ImageRotator.Create(id);
  if (props.licence) {
    viewer.licenseCode = props.licence;
  }

  if (props.rootPath) {
    viewer.settings.rootPath = props.rootPath;
  }

  viewer.settings.configFileURL = props.index;

  setTimeout(viewer.runImageRotator.bind(viewer), 100)
});

</script>

<style lang="scss">
@import '@webrotate360/imagerotator/build/css/zoom_dark.css';

.webRotate {
  width: 100%;
  height: 100%;
  padding: 0;
}
</style>